import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import GameSignals from "@/signals/GameSignals";
import Facade from "@/Facade";
import AddComponent from "@base/utils/AddComponent";

export default class BackgroundContainer extends BaseContainer {

    constructor(data) {
        super(data)
        this.init()
    }

    init(data) {
        Signals.introFreespins.add(this.onChangeFreespinMode, this)
        Signals.outroFreespinsComplete.add(this.onChangeFreespinMode, this)
        Signals.gameInited.add(this.onChangeFreespinMode, this)

        const addElement = (name, container, position, pref = 'decor') => {
            return AddComponent.addElement(name, container, position, pref, 1)
        }
        const addSpineAnimation = AddComponent.addSpineAnimationPlay

        this.background = addElement('background', this, [100, 10], '')
        addSpineAnimation('sea', 'basegame_sea', this.background, [1285, 1290])
        addSpineAnimation('palm_left2', 'coconut_tree_left_2', this.background, [1185, 1290])
        addSpineAnimation('palm_left1', 'coconut_tree_left_1', this.background, [1185, 1290])
        addSpineAnimation('palm_right', 'coconut_tree_right', this.background, [1525, 1180])
        addElement('bg_stones_left', this.background, [1890, 1510])
        addSpineAnimation('tiki_bar', 'base_tiki_bar_ani', this.background, [1295, 1360])

        this.logo = addElement('tikiz_n_juice_logo', this.background, [1100, 450], 'decor')
        this.fsBackground = addElement('fsBackground', this, [100, 10], '')

        addSpineAnimation('fs_sea', 'freespins_sea', this.fsBackground, [1285, 1290])
        addElement('freebg_stones_left', this.fsBackground, [2200, 1510])
        addSpineAnimation('fs_palm_left2', 'freespins_coconut_tree_left_2', this.fsBackground, [1185, 1290])
        addSpineAnimation('fs_palm_left1', 'freespins_coconut_tree_left_1', this.fsBackground, [1185, 1290])
        addSpineAnimation('fs_palm_right', 'freespins_coconut_tree_right1', this.fsBackground, [1525, 1180])

        addSpineAnimation('tiki_bar_fs', 'freespins_tiki_bar_ani', this.fsBackground, [1285, 1360])
        this.changeState(Facade.model.isFreespinsMode)

        this.interactive = true
        this.on('pointerdown', (e) => {
            GameSignals.backgroundTap.dispatch()
        })
        this.onOrientationChanged(Facade.orientation)
    }

    onChangeFreespinMode() {
        this.changeState(Facade.model.isFreespinsMode)
    }

    changeState(isFreespinsMode) {
        this.background.visible = !isFreespinsMode
        this.fsBackground.visible = isFreespinsMode
    }

    onOrientationChanged(orientationSymbol) {
        switch (orientationSymbol) {
            case 'Hd':
                this.logo.visible = false
                break;
            case 'Hm':
                this.logo.visible = false
                break
            case 'Vm':
                this.logo.visible = true
                break
        }
    }


}
